<template>
  <section class="panel panel-default">
    <div v-if="!addProduct" class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(addEdit)" method="post">
            <div class="row">
              <div class="col-md-4">
              <div class="col-12">
                <ValidationProvider
                  name="Received Date"
                      rules="required"
                      v-slot="{ errors }"
                  >
                <div class="form-group">
                  <label for="brand">
                    Received Date <span class="required-color">*</span></label
                  >
                  <input
                    type="date"
                    class="form-control"
                    id="received-date"
                    v-model="receivedDate"
                    autocomplete="off"
                    data-parsley-pattern-message="This is not a valid date"
                    data-parsley-trigger="keyup"
                    placeholder="Received Date"
                  />
                  <p style="color:red">{{ errors[0] }}</p>
                </div>
              
                    </ValidationProvider>
              </div>
                <!-- <div class="col-md-4">
                  <ValidationProvider
                    name="Delivery Location"
                        rules="required"
                        v-slot="{ errors }"
                    >
                  <div class="form-group">
                    <label for="location">
                      Delivery Location <span class="required-color">*</span></label
                    >                                
                        <v-select v-model="location" @input="setLocation" label="site_name" :options="locationList"></v-select>
                    <p style="color:red">{{ errors[0] }}</p>
                  </div>
                
                      </ValidationProvider>
                </div> -->
              <div class="col-12">
                <ValidationProvider name="supplier" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Supplier Name <span class="required-color">*</span></label>                  
                  <v-select label="supplier_name" @input="setSupplier" v-model="supplier" :options="supplierList"></v-select>
                    <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
                <div class="col-12">
                  <ValidationProvider
                    name="Remarks"
                        rules=""
                        v-slot="{ errors }"
                    >
                  <div class="form-group">
                    <label for="remraks">
                      Remarks</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="remarks"
                      v-model="remarks"
                      autocomplete="off"
                      data-parsley-trigger="keyup"
                      placeholder="Remarks"
                    />
                    <p style="color:red">{{ errors[0] }}</p>
                  </div>
                
                      </ValidationProvider>
                </div>
              </div>
              <div class="col-md-8">
              <div class="col-md-12">
                <table class="table">
                  <thead>
                    <tr>
                      <th colspan="3" class="product-cell">Product</th>
                      <th colspan="1" class="qty-cell">Quantity</th>
                      <!-- <th colspan="1" class="cost-cell">Unit Price</th>
                      <th colspan="1" class="total-cell">Sub Total</th> -->
                      <th colspan="1" class="icon-wrap"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <grn-line
                      v-for="(product, k) in cartItems"
                      :key="k"
                      :index="k"
                      :productList="productList"
                      :product="product"
                      @update-total="updateTotal"
                      @remove-row="removeRow"
                      @add-product = "addNewRow"
                    />
                    <tr>
                      <td colspan="7"><a href="#" style="text-decoration:underline;" @click="addNewRow()">Add Product</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
              </div>
            <div class="row">
            </div>
            <div class="modal-footer" style="text-align: right">
              <div class="col-sm-12">
                <button
                  :disabled="saveCat"
                  id="btn_save"
                  type="submit"
                  class="btn btn-success  text-center  "
                >
                  {{itemId ? 'Update' : 'Generate'}} GRN
                </button>
                <!-- <a
                  v-if="isAdmin && isWaitingApproval"
                  :disabled="saveCat"
                  v-on:click="approveLPO()"
                  class="btn btn-info  text-center"
                >
                  Approve LPO
                </a>
                <a
                  v-if="isAdmin && isWaitingApproval"
                  :disabled="saveCat"
                  v-on:click="rejectLPO()"
                  class="btn btn-warning  text-center"
                >
                  Reject LPO
                </a> -->
                <a
                  v-on:click="$emit('hide-form')"
                  class="btn btn-danger  text-center  "
                >
                  Close
                </a>
              </div>
            </div>
          </form>
        </ValidationObserver>
    </div>    
    <add-grn-product v-if="addProduct" @hide-form="addProduct = false" @add-product="setProduct"/>  
  </section>
</template>

<script>
import api from "../api";
import config from "../config";
import GrnLine from './GrnLine.vue'
import AddGrnProduct from "./AddGrnProduct.vue";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
  props: ["grnId","isCopy"],
  name: "AddGrn",
  data() {
    const today = new Date().toISOString().slice(0, 10);
    return {
      addProduct: false,
      saveCat: false,
      itemId: '',
      orderDate: today,
      expectedDate: '',
      currency: 'AED',
      referenceNumber: '',
      supplierContact: '',
      siteContactPerson: '',
      siteContactNo: '',
      supplier: '',
      project: '',
      location: '',
      paymentTerm: '',
      requestedBy: '',
      remarks: '',
      supplierList: [],
      productList: [],
      paymentList: [],
      projectList: [],
      locationList: [],
      productMaster: [],
      cartItems: [],
      errors : [],
      loading: false,
      hasVAT: true,
      lpoStatus: '',
      preparedBy: '',
      discount: 0
    };
  },
  components: {
    GrnLine,
    vSelect,
    AddGrnProduct
  },
  computed: {
    isWaitingApproval: function() {
      return this.lpoStatus == config.LPOWaiting && this.getStatus != 'Draft'
    },
    isAdmin: function () {
        if (this.$store.state.user && this.$store.state.user.user_role == this.$store.state.userroleAdmin) {
            return true
        } else {
            return false
        }
    },
    cartTotal: function () {
      var total = this.cartItems.reduce((acc, item) => acc + item.sub_total, 0)
      return total
    },
    taxAmount: function() {
      const vat = this.hasVAT ? 0.05 : 0;      
      const total = (this.cartTotal - this.discount) * vat;
      return total
    },
    totalAmount: function () {
      const total = this.cartTotal - this.discount + this.taxAmount;
      return total;
    },
    cartProducts: function () {
      var productList = this.cartItems.filter(function (obj) {
        return obj.product_id !== ''
      })
      return productList
    },
    getStatus: function () {
      if (this.itemId) {
        if (this.lpoStatus < 0) {
          return 'Rejected'
        } else if (this.lpoStatus > 0) {
          return 'Approved'
        } else {
          return 'Waiting for Approval'
        }
      } else {
        return 'Draft'
      }
    }
  },
  methods: {
    setProject: function (value) {
      this.getLocations(value.project_id);
    },
    setLocation: function (value) {
      console.log('location:',value);
      // this.siteContactPerson = value.site_supervisor;
      // this.siteContactNo = value.site_mobile;
      // this.requestedBy = value.site_engineer;
    },
    setSupplier: function (value) {
      this.supplierContact = value.contact_person;
      this.paymentTerm = this.paymentList.find(obj => { return obj.term_id == value.payment_term; });
    },
    updateTotal: function ($event) {
      this.cartItems[$event.key].product_id = $event.product_id
      this.cartItems[$event.key].quantity = $event.quantity
      // this.cartItems[$event.key].price = $event.price
      this.cartItems[$event.key].uom = $event.uom
      // this.cartItems[$event.key].sub_total = $event.sub_total
      this.cartItems[$event.key].product_name = $event.product_name
      // this.productsTotal += $event.sub_total
      this.productList = this.productList.filter(function (obj) {
        return obj.product_id !== $event.product_id
      })
    },
    setProduct: function ($event) {
      this.addProduct = false
      $event.forEach((item) => {
        this.cartItems.push(item)
      })
    },
    removeRow: function ($event) {
      this.cartItems = this.cartItems.filter(function (obj) {
        return obj.product_id !== $event.product_id
      })
      // this.productList.push($event)
    },
    addNewRow: function () {
      this.addProduct = true;
    },
    getSuppliers: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_suppliers", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.supplierList = response.data.values;
          } else {
            this.supplierList = data.supplierList;
          }
        });
    },
    getCartList: function(id) {
      const list = {
        filter: {
          purchase_id: id
        },
      };
      api
        .request("post", "GeneralApis/get_purchase_items", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          var cartList = [];
          if (data.errorcode) {
            this.cartItems = response.data.values;
          } else {
            cartList = data.cartList;
          }
          cartList.forEach(item => {
            this.cartItems.push({
              product_id: item.product_id,
              quantity: item.quantity,
              price: item.unit_price,
              uom: item.uom_name,
              sub_total: parseInt(item.quantity) * parseInt(item.unit_price),
              product_name: item.product_name
            })
          });
        });
    },
    getProducts: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_products", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.productList = response.data.values;
          } else {
            this.productList = data.productList;
            this.productMaster = this.productList
          }
        });
    },
    getProjects: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_projects", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.projectList = response.data.values;
          } else {
            this.projectList = data.projectList;
          }
        });
    },
    getLocations: function(id = null) {
      const list = { filter: {project_id: id} };
      api
        .request("post", "GeneralApis/get_sites", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.locationList = response.data.values;
          } else {
            this.locationList = data.siteList;
          }
        });
    },
    getPaymentTerms: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_payment_terms", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.paymentList = response.data.values;
          } else {
            this.paymentList = data.termList;          }
        });
    },
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.isCopy ? 0 : this.$props.grnId;
      this.errors = []
      const addItem = {
        "grn-form": {
          grn_id: this.itemId,
          product_list: this.cartProducts,
          grn_date:  this.orderDate,
          supplier_id:  this.supplier.supplier_id,
          supplier_name:  this.supplier.supplier_name,
          // site_id:  this.location.site_id,
          // site_name:  this.location.site_name,
          remarks: this.remarks,
          // requested_by:  this.requestedBy,
          prepared_by: this.preparedBy
        },
      };
      if (this.itemId > 0) {
        console.log('add_item', addItem)
        api
          .request("post", "GeneralApis/edit_grn", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        console.log('add_item', addItem)
        api
          .request("post", "GeneralApis/add_grn", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
    },
    approveLPO() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.$props.grnId;
      this.errors = []
      const formData = {
        "lpo-form": {
          purchase_id: this.itemId,
          order_status:  config.LPOApproved
        },
      };
      api
        .request("post", "GeneralApis/change_lpo_status", formData)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.response = data.errormessage;
            return;
          } else {
            alert("LPO Status Updated!");
            const purchaseList = data.purchaseList[0];
            this.lpoStatus = purchaseList.order_status;
          }
        });
    },
    rejectLPO() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.$props.grnId;
      this.errors = []
      const formData = {
        "lpo-form": {
          purchase_id: this.itemId,
          order_status:  config.LPORejected
        },
      };
      api
        .request("post", "GeneralApis/change_lpo_status", formData)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            this.response = data.errormessage;
            return;
          } else {
            alert("LPO Status Updated!");
            const purchaseList = data.purchaseList[0];
            this.lpoStatus = purchaseList.order_status;
          }
        });
    },
    getPurchase: function() {
      let currentDate = new Date();
      var purchase_id = this.$props.grnId;
      const today = currentDate.toISOString().slice(0, 10);
      currentDate.setDate(currentDate.getDate() + 1);
      const tomorrow = currentDate.toISOString().slice(0, 10);
        (this.cartItems = []),
        (this.orderDate = today),
        (this.expectedDate = tomorrow),
        (this.currency= "AED"),
        (this.referenceNumber=""),
        (this.supplierContact=""),
        (this.siteContactPerson=""),
        (this.siteContactNo=""),
        (this.supplier=""),
        (this.project=""),
        (this.location=""),
        (this.paymentTerm=""),
        (this.requestedBy=""),
        (this.remarks=""),
        (this.discount = 0),
        (this.itemId = 0);
      if (purchase_id > 0) {
        this.itemId = purchase_id;    
        const getItem = {
          filter: {
            purchase_id: this.itemId,
          },
        };
        api
          .request("post", "GeneralApis/get_purchases", getItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              const purchaseList = data.purchaseList[0];
              if (this.$props.isCopy) {
                this.itemId = 0;
              } else {
                this.orderDate = purchaseList.order_date;
                this.expectedDate = purchaseList.expected_date;
              }
              const cartList = data.cartList;
              this.currency = purchaseList.currency;
              this.referenceNumber = purchaseList.reference_number;
              this.supplierContact = purchaseList.supplier_contact_person;
              this.siteContactPerson = purchaseList.site_contact_person;
              this.siteContactNo = purchaseList.site_contact_number;
              this.requestedBy = purchaseList.requested_by;
              this.preparedBy = purchaseList.prepared_by;
              // this.supplier = this.supplierList.find(obj => { return obj.supplier_id == purchaseList.supplier_id; });
              // this.project = this.projectList.find(obj => { return obj.project_id == purchaseList.project_id; });
              // this.location = this.locationList.find(obj => { return obj.site_id == purchaseList.site_id; });
              // this.paymentTerm = this.paymentList.find(obj => { return obj.term_id == purchaseList.payment_term_id; });
              this.supplier = {supplier_id: purchaseList.supplier_id, supplier_name: purchaseList.supplier_name};
              this.project = {project_id: purchaseList.project_id, project_name: purchaseList.project_name};
              this.location = {site_id: purchaseList.site_id, site_name: purchaseList.site_name};
              this.paymentTerm = { term_id: purchaseList.payment_term_id, term_name: purchaseList.payment_term_name};
              this.remarks = purchaseList.remarks;
              this.lpoStatus = purchaseList.order_status;
              this.discount = purchaseList.discount;
              cartList.forEach(item => {
                this.cartItems.push({
                  product_id: item.product_id,
                  quantity: item.quantity,
                  price: item.unit_price,
                  uom: item.uom_name,
                  sub_total: parseInt(item.quantity) * parseInt(item.unit_price),
                  product_name: item.product_name
                })
              });
            }
          });
      }
    },
  },
  mounted() {
    this.preparedBy = this.$store.state.user.first_name + ' ' + this.$store.state.user.last_name
    this.getPurchase();
    this.getSuppliers();
    this.getProducts();
    this.getProjects();
    this.getLocations();
    this.getPaymentTerms();
    /* if (this.$props.grnId) {
      this.getCartList(this.$props.grnId)
    } */
  },
};
</script>

<style scoped>
  input{
    padding-top: 0;
    padding-bottom: 0;
    height: 25px;
  }
  .input-group-addon{
    padding-top:0;
    padding-bottom: 0;
  }
.product-cell{
  width: 60%;
}
.qty-cell{
  width: 10%;
}
.cost-cell{
  width: 12%;
}
.total-cell{
  width: 14%;
}
.icon-wrap{
  width: 4%;
}
.table{
  margin: 0 10px;
}
table th{
  padding: 2px;
}
</style>